// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__13Emh","calendarButtons":"ClockData_calendarButtons__pOAhe"};